import styled from '@emotion/styled';
import { useEffect, useMemo, useState } from 'react';

import { useDetermineMobile } from '@myrealtrip/device-detect';
import GlobalSearch from '../../../shared/components/GlobalSearch';

import { css } from '@emotion/css';
import { BenefitPageUrl } from '../../../constants/header';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import useGetPlaceholder from '../../../shared/components/GlobalSearch/hooks/apis/useGetPlaceholder';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import { COLOR, LAYOUT } from '../../../shared/types/globalSearch';
import media from '../../../shared/utils/mediaQuery';
import { sendClickLog } from '../../utils/sendClickLog';
import BenefitButton from '../BenefitButton';
import GlobalNavItems from '../GlobalNavItems';
import GnbLogo from '../GnbLogo';
import SearchButton from '../SearchButton';
import SideBar from '../SideBar';
import SideBarButton from '../SideBarButton';

export default function GNB() {
  const { theme, mainVerticalItems, isMainPage } = useLayoutHeaderContext();
  const isMobile = useDetermineMobile();
  const [isExperiencesPage, setIsExperiencesPage] = useState(false);
  const benefitLNBCategory = useMemo(
    () => mainVerticalItems?.find((item) => item.link.mobile_web.includes(BenefitPageUrl)),
    [mainVerticalItems],
  );

  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isSearchDialogOpen, setIsSearchDialogOpen] = useState(false);

  useEffect(() => {
    const pathname = window.location.pathname;
    const isExperiences = pathname === '/experiences' || pathname === '/experiences/';
    setIsExperiencesPage(isExperiences);
  }, []);

  const handleSearchDialogToggle = (isOpen: boolean) => setIsSearchDialogOpen(isOpen);
  const handleOpenSearchPopup = () => {
    sendClickLog({
      itemKind: 'button',
      screenName: WeblogScreenName.COMMON,
      pageCategory: WeblogPageCategory.COMMON,
      eventName: 'search_init_button',
      itemName: 'search_init_button',
    });

    handleSearchDialogToggle(true);
  };
  const handleOpenSideBar = () => setIsSideBarOpen(true);
  const handleCloseSideBar = () => setIsSideBarOpen(false);

  const { placeholder } = useGetPlaceholder();

  const renderMainHeader = () => {
    return (
      <Container>
        <MainLogoWrapper>
          <GnbLogo />
        </MainLogoWrapper>
        <MainHeaderWrapper>
          {benefitLNBCategory ? (
            <BenefitButton link={benefitLNBCategory.link.mobile_web} />
          ) : (
            <SearchButton
              onClick={handleOpenSearchPopup}
              className={css`
                padding: 8px 10px !important;
              `}
            />
          )}
          <SideBarButton
            onClick={handleOpenSideBar}
            className={css`
              padding: 8px 16px 8px 8px !important;
            `}
          />
        </MainHeaderWrapper>
        <GlobalSearch
          isShowSearchInput={false}
          isSuggestionDialogOpen={isSearchDialogOpen}
          onSuggestionDialogToggle={handleSearchDialogToggle}
          placeholder={placeholder}
        />
        {isSideBarOpen && (
          <SideBar isOpen={isSideBarOpen} direction="right" onClose={handleCloseSideBar} />
        )}
      </Container>
    );
  };

  const renderDefaultHeader = () => {
    return (
      <Container>
        <SideBarButton onClick={handleOpenSideBar} />
        <GnbLogo />
        <SearchButton onClick={handleOpenSearchPopup} />

        <GlobalSearch
          isShowSearchInput={false}
          isSuggestionDialogOpen={isSearchDialogOpen}
          onSuggestionDialogToggle={handleSearchDialogToggle}
          placeholder={placeholder}
        />
        {isSideBarOpen && <SideBar isOpen={isSideBarOpen} onClose={handleCloseSideBar} />}
      </Container>
    );
  };

  if (isMobile) {
    return isMainPage ? renderMainHeader() : renderDefaultHeader();
  }

  return (
    <Container>
      <GnbLogo />
      {/* TnA 홈에는 콘텐츠에 글로벌 검색 UI가 존재하므로 노출하지 않는다 */}
      {!isExperiencesPage && (
        <GlobalSearchContainer>
          <GlobalSearch
            variations={{
              layout: LAYOUT.header,
              color: theme === 'white' ? COLOR.white : COLOR.transparent,
            }}
            placeholder={placeholder}
          />
        </GlobalSearchContainer>
      )}
      <GlobalNavItems />
    </Container>
  );
}

const Container = styled.nav`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 72px;
  max-width: 1060px;
  margin: 0 auto;

  ${media.mobile} {
    justify-content: space-between;
    height: 48px;
  }
`;

const GlobalSearchContainer = styled.div`
  position: relative;
  width: 340px;
  height: 48px;
  margin-left: 24px;
`;

const MainLogoWrapper = styled.div`
  padding: 10px 16px;
`;

const MainHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;
